/**
 * Products archive filtering, sorting, and deep-linking.
 */
jQuery(document).ready(() => {
    const $root = jQuery('.products');
    if (!$root.length) {
        return;
    }

    const $filters = $root.find('.js-products-filters');
    const $grid = $root.find('.js-products-grid');
    const $cards = $grid.find('.product-card');
    const $count = $root.find('.js-products-count');
    const $empty = $root.find('.js-products-empty');
    const $sort = $root.find('.js-products-sort');
    const $toggle = $root.find('.js-filters-toggle');
    const mqDesktop = window.matchMedia('(min-width: 1024px)');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fadeMs = 550;
    let emptyTimer = null;

    $cards.each(function (index) {
        jQuery(this).attr('data-order', index);
    });

    function clearCardTimer($card) {
        const timer = $card.data('filterTimer');
        if (timer) {
            window.clearTimeout(timer);
            $card.removeData('filterTimer');
        }
    }

    function hideCard($card, animate) {
        if ($card.hasClass('is-hidden') && !$card.hasClass('is-hiding')) {
            return;
        }

        clearCardTimer($card);

        if (!animate || prefersReducedMotion) {
            $card.addClass('is-hidden').removeClass('is-hiding');
            return;
        }

        if ($card.hasClass('is-hiding')) {
            return;
        }

        $card.addClass('is-hiding');
        $card.data('filterTimer', window.setTimeout(() => {
            $card.addClass('is-hidden').removeClass('is-hiding');
            $card.removeData('filterTimer');
        }, fadeMs));
    }

    function showCard($card, animate) {
        if (!$card.hasClass('is-hidden') && !$card.hasClass('is-hiding')) {
            return;
        }

        clearCardTimer($card);

        if (!animate || prefersReducedMotion) {
            $card.removeClass('is-hidden is-hiding');
            return;
        }

        $card.removeClass('is-hidden').addClass('is-hiding');
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                $card.removeClass('is-hiding');
            });
        });
    }

    function getCheckedValues(name) {
        return $filters
            .find(`input[name="${name}"]:checked`)
            .map(function () {
                return jQuery(this).val();
            })
            .get();
    }

    function setCheckedValues(name, values) {
        const set = new Set(values || []);
        $filters.find(`input[name="${name}"]`).each(function () {
            this.checked = set.has(this.value);
        });
    }

    function readParamsFromUrl() {
        const params = new URLSearchParams(window.location.search);
        let categories = [];

        if (params.has('category')) {
            categories = params
                .get('category')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);
        }

        // Back-compat with existing nav hash links: /products/#rfi-locators
        if (!categories.length && window.location.hash) {
            const hash = window.location.hash.replace(/^#/, '').trim();
            if (hash && $filters.find(`input[name="category"][value="${hash}"]`).length) {
                categories = [hash];
            }
        }

        const sort = $sort.length ? (params.get('sort') || 'default') : 'default';

        return { categories, sort };
    }

    function writeParamsToUrl(state) {
        const params = new URLSearchParams(window.location.search);

        if (state.categories.length) {
            params.set('category', state.categories.join(','));
        } else {
            params.delete('category');
        }

        params.delete('stock');

        if (state.sort && state.sort !== 'default') {
            params.set('sort', state.sort);
        } else {
            params.delete('sort');
        }

        const query = params.toString();
        const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}`;
        window.history.replaceState({}, '', nextUrl);
    }

    function getFilterState() {
        return {
            categories: getCheckedValues('category'),
            sort: $sort.length ? ($sort.val() || 'default') : 'default',
        };
    }

    function applyFilters(updateUrl = true, animate = true) {
        const state = getFilterState();
        let visibleCount = 0;

        $cards.each(function () {
            const $card = jQuery(this);
            const cardCategories = String($card.data('categories') || '')
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);
            let visible = true;

            if (state.categories.length) {
                visible = state.categories.some((slug) => cardCategories.includes(slug));
            }

            if (visible && state.sort === 'featured') {
                visible = Number($card.attr('data-featured') || 0) === 1;
            }

            if (visible) {
                showCard($card, animate);
                visibleCount += 1;
            } else {
                hideCard($card, animate);
            }
        });

        const $sorted = $cards.get().sort((a, b) => {
            const aOrder = Number(jQuery(a).attr('data-order') || 0);
            const bOrder = Number(jQuery(b).attr('data-order') || 0);
            return aOrder - bOrder;
        });

        $grid.append($sorted);

        $count.text(visibleCount);

        window.clearTimeout(emptyTimer);
        if (visibleCount > 0) {
            $empty.prop('hidden', true);
        } else if (!animate || prefersReducedMotion) {
            $empty.prop('hidden', false);
        } else {
            emptyTimer = window.setTimeout(() => {
                $empty.prop('hidden', false);
            }, fadeMs);
        }

        if (updateUrl) {
            writeParamsToUrl(state);
        }
    }

    function syncFiltersFromUrl() {
        const state = readParamsFromUrl();
        setCheckedValues('category', state.categories);
        if ($sort.length) {
            $sort.val(state.sort);
        }
        applyFilters(false, false);

        // Normalize hash deep-links into query params.
        if (state.categories.length && window.location.hash) {
            writeParamsToUrl(state);
        }
    }

    function setFiltersOpen(open) {
        if (mqDesktop.matches) {
            $filters.prop('hidden', false);
            $toggle.attr('aria-expanded', 'true');
            $root.removeClass('is-filters-open');
            return;
        }

        $filters.prop('hidden', !open);
        $toggle.attr('aria-expanded', open ? 'true' : 'false');
        $root.toggleClass('is-filters-open', open);
    }

    function syncFiltersVisibility() {
        setFiltersOpen(mqDesktop.matches ? true : false);
    }

    $root.on('change', 'input[name="category"]', function () {
        applyFilters(true);
    });

    $root.on('click', '.js-reset-group', function (e) {
        e.preventDefault();
        const group = jQuery(this).data('group');
        $filters.find(`[data-filter-group="${group}"] input[type="checkbox"]`).prop('checked', false);
        applyFilters(true);
    });

    $root.on('click', '.js-filters-toggle', function (e) {
        e.preventDefault();
        setFiltersOpen($filters.prop('hidden'));
    });

    $root.on('click', '.js-filters-close', function (e) {
        e.preventDefault();
        setFiltersOpen(false);
    });

    if ($sort.length) {
        $sort.on('change', function () {
            applyFilters(true);
        });
    }

    // Nav category links → deep-link filters.
    jQuery('.navbar__nav a[href*="/products"]').on('click', function (e) {
        const href = jQuery(this).attr('href') || '';
        const url = new URL(href, window.location.origin);
        let category = '';

        if (url.hash) {
            category = url.hash.replace(/^#/, '');
        } else if (url.searchParams.get('category')) {
            category = url.searchParams.get('category').split(',')[0];
        }

        if (!category) {
            return;
        }

        if (window.location.pathname.replace(/\/$/, '') === url.pathname.replace(/\/$/, '')) {
            e.preventDefault();
            setCheckedValues('category', [category]);
            applyFilters(true);
            setFiltersOpen(mqDesktop.matches);
            $root.get(0).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    syncFiltersFromUrl();
    syncFiltersVisibility();

    if (typeof mqDesktop.addEventListener === 'function') {
        mqDesktop.addEventListener('change', syncFiltersVisibility);
    } else if (typeof mqDesktop.addListener === 'function') {
        mqDesktop.addListener(syncFiltersVisibility);
    }
});
